import { mapState } from "vuex";
// import Services from '../../services';

export default {
  data() {
    /*
     * require otpAttemptCounter, logoutUrl, uiUrl which was configured
     * */
    return {
      profile: "profile",
      redirectToWeb: "redirect-to-website",
      home: "home",
      loginChallenge: "login_challenge",
      loggedIn: "loggedIn",
      tokenTypeEntity: "tokenType",
      tokenTypeValue: "Bearer",
      accessTokenEntity: "accessToken",
      refreshToken: "refresh_token",
      idUserToken: "id_token",
      user_key: "user",
      sendOtp: "send-otp",
      verifyMobile: "verify-mobile",
      addMobileEntity: "add-mobile",
      signUp: "sign-up",
      signIn: "sign-in",
      verifyPage: "verify",
      nextUrl: "nextUrl",
      backTo: "backTo",
      errorMsg: {
        enterValidEmail: " Please enter a valid email address",
        enterValidUsername: "Please enter your email address or mobile number",
        enterValidPhone: "Please enter a valid phone number",
        enterPhone: "Please enter a Phone number",
        enterEmail: "Please enter an Email address",
      },
    };
  },

  methods: {
    getAuthDefaultPage() {
      return this.redirectToWeb;
    },

    getGuestDefaultPage() {
      return this.home;
    },

    getForgetPasswordPage() {
      return this.forgetPasswordEntity;
    },

    getResetPasswordPage() {
      return this.resetPassword;
    },

    getChangePasswordPage() {
      return this.changePasswordEntity;
    },

    getForcedPasswordChangePage() {
      return this.forcedPasswordEntity;
    },

    getVerifyPage() {
      return this.verifyPage;
    },

    getSignInPage() {
      return this.signIn;
    },

    getSignUpPage() {
      return this.signUp;
    },

    getAddMobileEntity() {
      return this.addMobileEntity;
    },

    getVerifyMobileEntity() {
      return this.verifyMobile;
    },

    getLoginInterceptor() {
      return this.loginChallenge;
    },

    getLoggedIn() {
      return this.loggedIn;
    },

    getUserEntity() {
      return this.user_key;
    },

    getAccessToken() {
      return this.accessTokenEntity;
    },

    getRefreshToken() {
      return this.refreshToken;
    },

    getUserIdToken() {
      return this.idUserToken;
    },

    getTokenType() {
      return this.tokenTypeEntity;
    },

    getTokenTypeValue() {
      return this.tokenTypeValue;
    },

    setLocalStorageData(entity_name, entity_value) {
      localStorage.setItem(entity_name, entity_value);
    },

    getLocalStorageData(entity_name) {
      return localStorage.getItem(entity_name);
    },

    clearLocalStorage() {
      localStorage.clear();
    },

    unsetLocalStorageData(entity_name) {
      localStorage.removeItem(entity_name);
    },

    windowRedirection(url) {
      window.location = url;
    },

    getNextUri() {
      return this.nextUrl;
    },

    getBackToUrl() {
      // Generic backTo url function, which will return return variable
      return this.backTo;
    },

    redirectForLoggedUser() {
      if (this.getLocalStorageData(this.getNextUri())) {
        let redirect_uri = this.getLocalStorageData(this.getNextUri());
        this.unsetLocalStorageData(this.getNextUri());
        this.$router.push({ name: redirect_uri }, () => {});
      }
      if (this.$route.meta.auth)
        this.$router.push({ name: this.$route.name }, () => {});
      else this.$router.push({ name: this.getAuthDefaultPage() }, () => {});
    },

    hideErrorMessage() {
      this.resetError();
    },

    validateInput(obj, input, value) {
      if (value) {
        return obj.hasOwnProperty(input) && obj.input === value;
      } else {
        return obj.hasOwnProperty(input);
      }
    },
    iOS() {
      return (
        [
          "iPad Simulator",
          "iPhone Simulator",
          "iPod Simulator",
          "iPad",
          "iPhone",
          "iPod",
        ].includes(navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes("Mac") && "ontouchend" in document)
      );
    },
  },

  beforeMount() {
    if (this.$route.query.hideBack) {
      this.setLocalStorageData("hideBack", this.$route.query.hideBack);
    }
    if (this.$route.query.load_uri) {
      /*
       * Generate back url, in that case of mobile verification
       * once back url generate, set in localStorage, so once user verify account based on back url, redirect back to same page
       * */
      if (this.$route.query.back) {
        let backTo = "";
        backTo += this.$route.query.back;
        if (this.$route.query.id || this.$route.query.ltt) {
          backTo += "?";
        }
        if (this.$route.query.id) {
          backTo += "id=" + this.$route.query.id + "&";
        }
        if (this.$route.query.ltt) {
          backTo += "ltt=" + this.$route.query.ltt;
        }
        this.setLocalStorageData(this.getBackToUrl(), backTo);
      }
      this.setLocalStorageData(this.getNextUri(), this.$route.query.load_uri);
    }

    if (this.$route.query.access_token) {
      this.$store
        .dispatch("users/getToken", {
          access_token: this.$route.query.access_token,
          refresh_token: this.$route.query.refresh_token,
          id_token: this.$route.query.id_token,
        })
        .then(() => {
          this.$store
            .dispatch("users/getUserInfo", {
              token_type: this.getTokenTypeValue(),
              access_token: this.saved_accessToken,
            })
            .then(() => {
                return this.redirectForLoggedUser();
            });
        });
    }

    if (this.saved_userStatus) {
      return this.redirectForLoggedUser();
    } else if (this.$route.meta.auth) {
      this.$router.push({ name: this.getGuestDefaultPage() }, () => {});
    }
  },

  computed: {
    ...mapState("users", {
      saved_accessToken: "accessToken",
      saved_refreshToken: "refreshToken",
      saved_idToken: "idToken",
      saved_userInfo: "userInfo",
      saved_userStatus: "userStatus",
      saved_reSendCurrentTime: "reSendCurrentTime",
    }),
    showBackCta: function () {
      let backCta = true;
      let hideBack = this.getLocalStorageData("hideBack") || false;
      if (hideBack) {
        backCta = false;
      }
      return backCta;
    },
  },

  created() {
    this.$root.$on("hideMessage", this.hideErrorMessage);
  },
  beforeDestroy() {
    this.unsetLocalStorageData("hideBack");
  },
};
